import { graphql } from "gatsby"
import { useStaticQuery } from "gatsby"
import { ImageDataLike } from "gatsby-plugin-image"
import React from "react"
import "twin.macro"
import { GatsbyImage, getImage, IGatsbyImageData } from "gatsby-plugin-image"
type dataType = {
  allStoriesJson: {
    nodes: {
      date: string
      content: string
      title: string

      images: ImageDataLike // it should always same varaible okay now good
    }[]
  }
}
const Stories = () => {
  const data: dataType = useStaticQuery(graphql`
    query MyDataQuery {
      allStoriesJson {
        nodes {
          date
          content
          title
          images {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `)
  return (
    <div
      tw=" mt-24 mb-0.5  max-w-7xl mx-auto p-5 pb-24 pt-2 bg-green-200"
      id="STORIES"
    >
      <p tw="text-6xl text-center mb-3">My Stories & Latest News</p>
      <div tw="text-xl font-extralight max-w-3xl mx-auto mb-6">
        Aliquam a augue suscipit, luctus neque purus ipsum neque dolor primis
        libero tempus, tempor posuere ligula varius augue luctus donec sapien
        ndv kkjxdqws njs neym messi
      </div>
      <div tw="grid md:grid-cols-3 gap-1 mx-auto mr-4">
        {data.allStoriesJson.nodes.map((item, index) => {
          const image1 = getImage(item.images)
          return (
            <div tw="pt-2 space-x-4">
              <img
                src={``}
                tw="transform scale-x-50 scale-y-50 text-pink-600"
              ></img>
              <GatsbyImage image={image1 as IGatsbyImageData} alt="pic" />
              <div tw="flex justify-center">{item.date}</div>
              <div tw=" flex justify-center text-xl font-bold hover:text-red-500 hover:underline mt-4">
                {item.title}
              </div>
              <div tw=" font-extralight ml-6 mt-4 mx-auto">{item.content}</div>
            </div>
          )
        })}{" "}
      </div>{" "}
      <div tw="  mt-24 text-xl  flex justify-center">
        <button tw="bg-red-500 rounded-full py-3 px-5 border-r-0 focus:outline-none p-5 text-blue-50 font-extrabold">
          Read All Post
        </button>
      </div>
    </div>
  )
}

export default Stories
